import { animate, style, transition, trigger } from '@angular/animations';

export default [
  trigger('fadeInOut', [
    transition(':enter', [
      // Ao entrar
      style({ opacity: 0 }), // Começa invisível
      animate('75ms ease-in', style({ opacity: 1 })) // Fica visível
    ]),
    transition(':leave', [
      // Ao sair
      animate('150ms ease-out', style({ opacity: 0 })) // Desvanece
    ])
  ])
];
